export default "__VITE_ASSET__CuGIU7nc__"